export const homeSizeStyles = 'lg:max-w-[940px] xl:max-w-[1040px] max-w-full'
